import HaxeBackend from '@/components/HaxeBackend/HaxeBackend';
import { observer } from 'mobx-react-lite';
import React from 'react';

import './ScreenGame.css';

const ScreenGame = () => {

  return (
    <div className={"ScreenGame"}>
      
      <HaxeBackend visible={true}/>

    </div>
  );
};

export default observer(ScreenGame)
